import React from 'react';

import { withLayoutAndSession } from '@utils/hocs';
import { colorsByTheme } from '@utils/constants/colors';
import ImageBackground from '@components/_shared/imageBackground';
import Button from '@components/_shared/button';

const Custom404 = () => (
  <ImageBackground
    backgroundImageStyle={`
        ${colorsByTheme['dark'].imageBackgroundWithGradientTopBottom},
        url('/images/not-found.jpg')
      `}
  >
    <div className="not-found">
      <section>
        <h1>404 error</h1>
        <p>Sorry, the page you are looking for does not exist.</p>
        <Button to="/" variant="greenContained">
          Go back home
        </Button>
      </section>
    </div>
  </ImageBackground>
);

export default withLayoutAndSession(Custom404, {
  headerProps: { theme: 'dark' },
  footerProps: {
    theme: 'dark',
  },
});
